/**
 * Refactor from the OOB mapProductDetailsData
 * The OOB Product.items donot contain all necessary information from SKUs.
 * In this custom version, use input SKU to replace Product.items
 */

import { STRING_TRUE } from '@/data/constants/catalog';
import { ProductAttribute, ProductType, Selection } from '@/data/types/Product';
import { getAttrsByIdentifier, search } from '@/data/utils/mapProductDetailsData';

const findSkuIndexFromProductThumbnail = (catentry: ProductType) => {
	const thumbnail = catentry.thumbnail;
	const skus = catentry.items ?? [];
	return skus.findIndex((sku) => sku.thumbnail === thumbnail);
};

const initialize = (
	input?: ProductType,
	toFind?: ProductAttribute[],
	child?: ProductType
): { product: ProductType; selection: Selection } | undefined => {
	if (!input) return undefined;
	const product = input;
	const skus = input.items?.length ? input.items : [input];
	let find = -1;
	let attrsByIdentifier;
	if (toFind) {
		attrsByIdentifier = getAttrsByIdentifier(toFind);
		const skusAsAttrs = skus.map((s) => getAttrsByIdentifier(s.definingAttributes));
		const { exact } = search(attrsByIdentifier, '', skusAsAttrs);
		find = exact;
	}
	if (find === -1) {
		find = findSkuIndexFromProductThumbnail(input);
	}
	const matchingSku = skus[find === -1 ? 0 : find];
	const sku = child ?? matchingSku;
	// if child catentry is provide, substitute it, assuming child has more data.
	if (child) {
		product.items = skus.map((s) => (s.id === child.id ? child : s));
	}
	if (!attrsByIdentifier) {
		attrsByIdentifier = getAttrsByIdentifier(sku.definingAttributes);
	}
	const selection = {
		sku,
		quantity: Number(sku?.['x_measurements.nominalQuantity'] ?? '1'),
		attrsByIdentifier,
		buyable: sku.buyable === STRING_TRUE,
	};

	return { product, selection };
};

/**
 *
 * @param catentry catentry can be SKU or Parent product itself.
 * @param parentCE parent catentry if catentry is item, otherwise, null.
 * @returns
 */
export const HDMMapProductDetailsData = (
	catentry: ProductType | undefined,
	parentCE: ProductType | undefined
) => {
	const { type, definingAttributes } = catentry ?? {};
	let product = parentCE ?? catentry;
	let selection: Selection | undefined;

	const isValidType = ['item', 'product', 'variant', 'package'].includes(type ?? '');

	if (parentCE) {
		const result = initialize(parentCE, definingAttributes, catentry);
		if (result) {
			product = result.product;
			selection = result.selection;
		}
	} else if (isValidType && catentry) {
		selection = initialize(catentry)?.selection;
	}
	return { product, selection };
};
